import {
  faAddressBook,
  faAnalytics,
  faArchive,
  faArrowCircleLeft,
  faArrowCircleRight,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowRightToBracket,
  faArrowUp,
  faAt,
  faBackspace,
  faBan,
  faBell,
  faBellSlash,
  faBooks,
  faBoxOpenFull,
  faBriefcase,
  faBuilding,
  faCalendar,
  faChartBar,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronsUp,
  faCircle,
  faCircleDollar,
  faClipboardCheck,
  faClock,
  faClone,
  faCloud,
  faCode,
  faCog,
  faComment,
  faCommentAltSlash,
  faCommentDots,
  faCommentsAlt,
  faCompressAlt,
  faCopy,
  faCreditCard,
  faDizzy,
  faDollarSign,
  faDoorOpen,
  faDotCircle,
  faDownload,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faExclamationCircle,
  faExclamationSquare,
  faExpand,
  faExpandAlt,
  faExternalLink,
  faEye,
  faEyeSlash,
  faFax,
  faFile,
  faFileAlt,
  faFileArchive,
  faFilePdf,
  faFileSignature,
  faFileSpreadsheet,
  faFileWord,
  faFilter,
  faFlag,
  faFolder,
  faFontCase,
  faFrownOpen,
  faGlobe,
  faGrimace,
  faGrin,
  faGrinBeam,
  faGrinStars,
  faHeart,
  faHighlighter,
  faHome,
  faImagePolaroid,
  faInbox,
  faInfoCircle,
  faItalic,
  faKey,
  faKissWinkHeart,
  faLightbulbOn,
  faLink,
  faLock,
  faLongArrowUp,
  faMapMarkerAlt,
  faMeh,
  faMicrophone,
  faMicrophoneSlash,
  faMoneyCheck,
  faMusic,
  faPaperPlane,
  faPaperclip,
  faPause,
  faPauseCircle,
  faPen,
  faPencil,
  faPhone,
  faPhoneSquare,
  faPlay,
  faPlayCircle,
  faPlus,
  faPlusCircle,
  faPollH,
  faQuestionCircle,
  faRectangleXmark,
  faReply,
  faReplyAll,
  faRightFromBracket,
  faRightToBracket,
  faSadTear,
  faSearch,
  faSearchPlus,
  faShare,
  faShieldCheck,
  faSmile,
  faSmileBeam,
  faSortAmountDown,
  faSplit,
  faSquarePollHorizontal,
  faStar,
  faStickyNote,
  faStop,
  faStopCircle,
  faSync,
  faTag,
  faTextHeight,
  faThumbsUp,
  faTicket,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUnderline,
  faUnlink,
  faUpload,
  faUser,
  faUserCheck,
  faUserCircle,
  faUserFriends,
  faUserHeadset,
  faUserPlus as faUserPlusRegular,
  faUserShield,
  faUserSlash,
  faUserTimes,
  faUsers,
  faUsersClass,
  faVideo,
  faVideoSlash,
  faVoicemail,
  faVolume,
  faVolumeSlash,
  faWandMagicSparkles,
  faWindowMaximize,
} from '@fortawesome/pro-regular-svg-icons';

const proRegularSvgIcons = {
  add: faPlus,
  addCircle: faPlusCircle,
  addUser: faUserPlusRegular,
  addressBookRegular: faAddressBook,
  analytics: faAnalytics,
  archive: faArchive,
  at: faAt,
  attachment: faPaperclip,
  back: faArrowLeft,
  backspace: faBackspace,
  books: faBooks,
  briefcase: faBriefcase,
  building: faBuilding,
  calendar: faCalendar,
  calendarRegular: faCalendar, // TODO: delete this one
  callFlow: faSplit,
  cancel: faBan,
  charts: faSquarePollHorizontal,
  checkCircle: faCheckCircle,
  chevronDown: faChevronDown,
  chevronLeft: faChevronLeft,
  chevronRight: faChevronRight,
  chevronUp: faChevronUp,
  chevronUpDouble: faChevronsUp,
  clipboard: faClipboardCheck,
  close: faTimes,
  closeSquare: faRectangleXmark,
  cloud: faCloud,
  code: faCode,
  faComment: faComment,
  comments: faCommentsAlt,
  compress: faCompressAlt,
  contacts: faUserCircle,
  copy: faCopy,
  delete: faTrashAlt,
  doc: faFileWord,
  dollar: faDollarSign,
  dotCircle: faDotCircle,
  down: faArrowDown,
  download: faDownload,
  edit: faEdit,
  excel: faFileSpreadsheet,
  exclamation: faExclamationCircle,
  expand: faExpandAlt,
  fax: faFax,
  file: faFile,
  fileAlt: faFileAlt,
  filter: faFilter,
  flag: faFlag,
  folder: faFolder,
  font: faFontCase,
  fontSize: faTextHeight,
  forward: faShare,
  front: faArrowRight,
  graph: faChartBar,
  headset: faUserHeadset,
  help: faQuestionCircle,
  hide: faEyeSlash,
  home: faHome,
  image: faImagePolaroid,
  inbox: faInbox,
  info: faInfoCircle,
  insights: faLightbulbOn,
  italic: faItalic,
  key: faKey,
  link: faLink,
  location: faMapMarkerAlt,
  lock: faLock,
  longUp: faLongArrowUp,
  mail: faEnvelope,
  marker: faHighlighter,
  mute: faMicrophoneSlash,
  newWindow: faExternalLink,
  notification: faBell,
  notificationOff: faBellSlash,
  pause: faPause,
  pauseCircle: faPauseCircle,
  pdf: faFilePdf,
  pen: faPen,
  pencil: faPencil,
  phone: faPhone,
  phoneSquare: faPhoneSquare,
  play: faPlay,
  playCircle: faPlayCircle,
  preview: faSearchPlus,
  record: faCircle,
  refresh: faSync,
  remove: faTimesCircle,
  removeUser: faUserTimes,
  reply: faReply,
  replyAll: faReplyAll,
  report: faPollH,
  ringtones: faMusic,
  room: faDoorOpen,
  search: faSearch,
  send: faPaperPlane,
  settings: faCog,
  smile: faSmile,
  sms: faCommentDots,
  sortDown: faSortAmountDown,
  star: faStar,
  stickyNote: faStickyNote,
  stop: faStop,
  stopCircle: faStopCircle,
  tag: faTag,
  team: faUsers,
  ticket: faTicket,
  time: faClock,
  clone: faClone,
  underline: faUnderline,
  unmute: faMicrophone,
  up: faArrowUp,
  upload: faUpload,
  url: faGlobe,
  user: faUser,
  userCheck: faUserCheck,
  userSlash: faUserSlash,
  userShield: faUserShield,
  users: faUserFriends,
  videoOff: faVideoSlash,
  videoOn: faVideo,
  voicemail: faVoicemail,
  volume: faVolume,
  volumeSlash: faVolumeSlash,
  watch: faEye,
  window: faWindowMaximize,
  zip: faFileArchive,
  fullScreen: faExpand,
  signature: faFileSignature,
  squareExclamation: faExclamationSquare,
  unLink: faUnlink,
  faArrowCircleLeft,
  faArrowCircleRight,
  faCommentAltSlash,
  faDizzy,
  faEllipsisV,
  faFrownOpen,
  faGrimace,
  faGrin,
  faGrinBeam,
  faGrinStars,
  faHeart,
  faKissWinkHeart,
  faMeh,
  faShieldCheck,
  faSadTear,
  faSmileBeam,
  faUsersClass,
  faThumbsUp,
  joinMeeting: faArrowRightToBracket,
  joinRoom: faRightToBracket,
  leaveRoom: faRightFromBracket,
  circleDollar: faCircleDollar,
  cancelPresentation: faRectangleXmark,
  automations: faWandMagicSparkles,
  creditCard: faCreditCard,
  boxOpenFull: faBoxOpenFull,
  moneyCheck: faMoneyCheck,
} as const;

export { proRegularSvgIcons };
